/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Properties of an FSx ONTAP volume.
*/
export class FsxOntapVolume {
  /**
  * The ID of the volume.
  */
  'volumeId'?: string;
  /**
  * The name of the volume.
  */
  'name'?: string;
  /**
  * The size of the volume in bytes.
  */
  'sizeBytes'?: number;
  /**
  * The junction path where the volume is mounted.
  */
  'junctionPath'?: string;
  /**
  * The ID of the Storage Virtual Machine (SVM) that the volume belongs to.
  */
  'storageVirtualMachineId'?: string;
  /**
  * The type of ONTAP volume (RW or DP).
  */
  'volumeType'?: FsxOntapVolumeVolumeTypeEnum;
  /**
  * The security style for the volume.
  */
  'securityStyle'?: FsxOntapVolumeSecurityStyleEnum;
  /**
  * Whether storage efficiency is enabled.
  */
  'storageEfficiencyEnabled'?: boolean;
  /**
  * The snapshot policy for the volume.
  */
  'snapshotPolicy'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "volumeId",
      "baseName": "volumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "junctionPath",
      "baseName": "junctionPath",
      "type": "string",
      "format": ""
    },
    {
      "name": "storageVirtualMachineId",
      "baseName": "storageVirtualMachineId",
      "type": "string",
      "format": ""
    },
    {
      "name": "volumeType",
      "baseName": "volumeType",
      "type": "FsxOntapVolumeVolumeTypeEnum",
      "format": ""
    },
    {
      "name": "securityStyle",
      "baseName": "securityStyle",
      "type": "FsxOntapVolumeSecurityStyleEnum",
      "format": ""
    },
    {
      "name": "storageEfficiencyEnabled",
      "baseName": "storageEfficiencyEnabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "snapshotPolicy",
      "baseName": "snapshotPolicy",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FsxOntapVolume.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum FsxOntapVolumeVolumeTypeEnum {
  Rw = 'RW',
  Dp = 'DP'
}
export enum FsxOntapVolumeSecurityStyleEnum {
  Unix = 'UNIX',
  Ntfs = 'NTFS',
  Mixed = 'MIXED'
}

